import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartColumn, faCommentSms, faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import pushNotificationVideo from "../assets/video/notification.mp4";

const featuresData = [
  {
    id: "call",
    label: "Call",
    icon: faPhone,
    title: "Call",
    image: "/themes/thesaas/img/c2c/feature_call.png",
    points: [
      "Uninterrupted call experiences with low latency API capabilities",
      "Integrate with your business website to ease the customer communication process",
    ],
  },
  {
    id: "sms",
    label: "SMS",
    icon: faCommentSms,
    title: "SMS",
    image: "/themes/thesaas/img/c2c/feature_sms.png",
    points: [
      "Power your customer engagement through SMS",
      "One inbox for any and every interaction",
      "Receive important information from your customer anytime, anywhere",
      "Enhance on-the-go interactions with seamless connection and intelligent media integrations",
    ],
  },
  {
    id: "email",
    label: "Email",
    icon: faEnvelope,
    title: "Email",
    image: "/themes/thesaas/img/c2c/feature_email.png",
    points: [
      "Emails enable customer support to react faster",
      "Reach new and already engaged customers",
      "Grow your customer list, reach a wider audience",
      "Get actionable insights to grow your business through email",
    ],
  },
  {
    id: "reports",
    label: "Reports",
    icon: faChartColumn,
    title: "Reports",
    image: "/themes/thesaas/img/c2c/feature_reports.png",
    points: [
      "Using BI, it generates actionable insights to make better-informed decisions",
      "Clear and concise reports to measure several facets of performance with data insights",
    ],
  },
];

const benefitsData = [
  {
    id: "leads",
    label: "Promising Leads",
    title: "Promising Leads",
    image: "/themes/thesaas/img/c2c/benefit_1.png",
    description:
      "Bring leads in one click in mere seconds, obtaining insights, instantly turning them into prospects at a swifter rate. It stores every interaction and nurtures lead at every stage of your business process.",
  },
  {
    id: "dynamic",
    label: "Dynamic and Adaptable",
    title: "Dynamic and Adaptable",
    image: "/themes/thesaas/img/c2c/benefit_2.png",
    description:
      "Unified brand experience and quality services for personalized customer query resolutions across multiple channels. This intelligent application scales itself, offering consistent and right support.",
  },
  {
    id: "ease",
    label: "Ease of Contact",
    title: "Ease of Contact",
    image: "/themes/thesaas/img/c2c/benefit_3.png",
    description:
      "Gain immediate data insights to make better-informed business decisions. Plan and execute end-to-end decisions with data analytics insights in one place.",
  },
  {
    id: "satisfied",
    label: "Satisfied Customer",
    title: "Satisfied Customer",
    image: "/themes/thesaas/img/c2c/Satisfiedcustomer.png",
    description:
      "It's important to target the right customer at the right time. The click to call technology allows you to intelligently segment your customers, directing calls from certain webpages to a specific department to best serve the customer's needs.",
  },
  {
    id: "segmentation",
    label: "Customer Segmentation",
    title: "Customer Segmentation",
    image: "/themes/thesaas/img/c2c/benefit_5.png",
    description:
      "C2C will divide your customers based on demographic, geographic, and behavioral parameters to improve products or service opportunities.",
  },
  {
    id: "nodialing",
    label: "No Number Dialing",
    title: "No Number Dialing",
    image: "/themes/thesaas/img/c2c/benefit_6.png",
    description:
      "C2C eliminates the process of dialing a number or navigating through call hunt. Instead, it enables the customer to get connected with an optimal representative with just one touch.",
  },
];

const faqData = [
  {
    question: "What is Context to Call?",
    answer:
      "Context to Call is an application for increasing business service efficiency by connecting the end-user to the business.",
  },
  {
    question: "Will I be charged when I create an account?",
    answer: "No, it is free. You get the first 10 Calls/SMS/Email for $0.",
  },
  {
    question: "How can I enable the Call/SMS/Email button on my website?",
    answer: "You can do this by fetching the unique Embed Code after Signing Up.",
  },
  {
    question: "How can I get help and support?",
    answer:
      'The product has a comprehensive manual that describes all sections of it in detail with proper screenshots. Still, if you have any queries or seek further support, our support team can be reached by using any of the buttons on the "Quick Connect" section on the footer of this website.',
  },
  {
    question: "What will be my username once I signup?",
    answer: "Your email id used at the time of signup will be your username.",
  },
];

const styles = {
  page: {
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    color: "var(--text-primary)",
    backgroundColor: "var(--bg-primary)",
    overflowX: "hidden",
  },
  hero: {
    background: "linear-gradient(135deg, #0f3460 0%, #16213e 60%, #0d7377 100%)",
    color: "#fff",
    textAlign: "center",
    padding: "80px 20px 60px",
  },
  heroSubtitle: {
    fontSize: "13px",
    letterSpacing: "3px",
    textTransform: "uppercase",
    color: "#14e3e3",
    marginBottom: "12px",
  },
  heroTitle: {
    fontSize: "clamp(36px, 6vw, 64px)",
    fontWeight: "800",
    lineHeight: 1.1,
    margin: "0 0 20px",
  },
  heroDesc: {
    fontSize: "18px",
    opacity: 0.8,
    maxWidth: "560px",
    margin: "0 auto",
    lineHeight: 1.6,
  },

  section: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "72px 24px",
  },
  sectionLabel: {
    fontSize: "12px",
    letterSpacing: "3px",
    textTransform: "uppercase",
    color: "var(--cyan-400)",
    fontWeight: "700",
    marginBottom: "8px",
  },
  sectionTitle: {
    fontSize: "clamp(26px, 4vw, 40px)",
    fontWeight: "800",
    marginBottom: "40px",
    color: "var(--text-primary)",
  },

  tabBar: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    marginBottom: "36px",
  },
  tab: (active) => ({
    padding: "10px 22px",
    borderRadius: "30px",
    border: "2px solid",
    borderColor: active ? "var(--cyan-500)" : "var(--site-border)",
    background: active ? "var(--cyan-500)" : "transparent",
    color: active ? "#fff" : "var(--text-secondary)",
    fontWeight: "600",
    fontSize: "14px",
    cursor: "pointer",
    transition: "all 0.2s",
  }),
  tabIcon: {
    marginRight: "8px",
  },

  featureCard: {
    display: "flex",
    gap: "48px",
    alignItems: "center",
    background: "var(--surface)",
    borderRadius: "20px",
    padding: "40px",
    boxShadow: "var(--shadow-md)",
    border: "1px solid var(--site-border)",
    flexWrap: "wrap",
  },
  featureImg: {
    width: "260px",
    maxWidth: "100%",
    borderRadius: "12px",
    objectFit: "contain",
  },
  featureContent: { flex: 1, minWidth: "200px" },
  featureTitle: {
    fontSize: "28px",
    fontWeight: "800",
    color: "var(--text-primary)",
    marginBottom: "20px",
  },
  featurePoint: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    marginBottom: "12px",
    fontSize: "15px",
    color: "var(--text-secondary)",
    lineHeight: 1.6,
  },
  bullet: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    background: "var(--cyan-500)",
    marginTop: "7px",
    flexShrink: 0,
  },

  mapSection: {
    background: "linear-gradient(135deg, #0f3460, #0d7377)",
    color: "#fff",
    textAlign: "center",
    padding: "72px 24px",
  },
  mapImg: {
    maxWidth: "900px",
    width: "100%",
    marginTop: "32px",
    borderRadius: "12px",
    opacity: 0.95,
  },

  benefitsLayout: {
    display: "grid",
    gridTemplateColumns: "minmax(220px, 0.38fr) minmax(0, 1fr)",
    gap: "28px",
    alignItems: "stretch",
  },
  benefitNav: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  benefitTab: (active) => ({
    width: "100%",
    textAlign: "left",
    background: active ? "linear-gradient(135deg, var(--cyan-500), var(--emerald-500))" : "var(--surface)",
    color: active ? "#fff" : "var(--text-primary)",
    borderRadius: "12px",
    padding: "16px 18px",
    cursor: "pointer",
    boxShadow: active
      ? "0 12px 32px rgba(6, 182, 212, 0.24)"
      : "var(--shadow-sm)",
    transition: "all 0.25s",
    border: "1px solid",
    borderColor: active ? "rgba(6, 182, 212, 0.45)" : "var(--site-border)",
  }),
  benefitTabTitle: { fontSize: "15px", fontWeight: "800", margin: 0 },
  benefitDetail: {
    display: "flex",
    gap: "32px",
    alignItems: "center",
    flexWrap: "wrap",
    minHeight: "100%",
    background: "var(--surface)",
    borderRadius: "16px",
    padding: "32px",
    boxShadow: "var(--shadow-md)",
    border: "1px solid var(--site-border)",
  },
  benefitDetailTitle: {
    fontSize: "clamp(22px, 3vw, 32px)",
    fontWeight: "800",
    color: "var(--text-primary)",
    marginBottom: "12px",
  },
  benefitDetailDesc: {
    fontSize: "15px",
    color: "var(--text-secondary)",
    lineHeight: 1.7,
    maxWidth: "620px",
  },

  pushSection: {
    background: "linear-gradient(135deg, rgba(6, 182, 212, 0.08), rgba(16, 185, 129, 0.08))",
    borderTop: "1px solid var(--site-border)",
    borderBottom: "1px solid var(--site-border)",
  },
  pushLayout: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 0.9fr) minmax(320px, 1.1fr)",
    gap: "40px",
    alignItems: "center",
  },
  pushDescription: {
    fontSize: "16px",
    color: "var(--text-secondary)",
    lineHeight: 1.7,
    maxWidth: "520px",
    margin: 0,
  },
  pushVideoFrame: {
    overflow: "hidden",
    borderRadius: "18px",
    background: "#0a0e17",
    border: "1px solid rgba(6, 182, 212, 0.2)",
    boxShadow: "0 20px 50px rgba(15, 23, 42, 0.18)",
    aspectRatio: "16 / 9",
  },
  pushVideo: {
    display: "block",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  faqSection: {
    background: "var(--surface)",
  },
  faqItem: {
    borderBottom: "1px solid var(--site-border)",
    padding: "20px 0",
  },
  faqQuestion: {
    fontSize: "16px",
    fontWeight: "700",
    color: "var(--text-primary)",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    userSelect: "none",
  },
  faqAnswer: {
    fontSize: "15px",
    color: "var(--text-secondary)",
    lineHeight: 1.7,
    marginTop: "12px",
    paddingRight: "24px",
  },
};

export default function FeaturesPage() {
  const [activeFeature, setActiveFeature] = useState("call");
  const [activeBenefit, setActiveBenefit] = useState("leads");
  const [openFaq, setOpenFaq] = useState(null);

  const currentFeature = featuresData.find((f) => f.id === activeFeature);
  const currentBenefit = benefitsData.find((b) => b.id === activeBenefit);

  return (
    <div style={styles.page}>
      {/* Hero */}
      <section style={styles.hero}>
        <p style={styles.heroSubtitle}>Features</p>
        <h1 style={styles.heroTitle}>
          Easy. Efficient.{" "}
          <span style={{ color: "#14e3e3" }}>Powerful.</span>
        </h1>
        <p style={styles.heroDesc}>
          Gain instant insights into customer queries and increase customer
          satisfaction.
        </p>
      </section>

      {/* Feature Tabs */}
      <div style={styles.section}>
        <p style={styles.sectionLabel}>Features</p>
        <h2 style={styles.sectionTitle}>Communication Channels</h2>

        <div style={styles.tabBar}>
          {featuresData.map((f) => (
            <button
              key={f.id}
              style={styles.tab(activeFeature === f.id)}
              onClick={() => setActiveFeature(f.id)}
            >
              <FontAwesomeIcon icon={f.icon} style={styles.tabIcon} /> {f.label}
            </button>
          ))}
        </div>

        {currentFeature && (
          <div style={styles.featureCard}>
            <img
              src={currentFeature.image}
              alt={currentFeature.title}
              style={styles.featureImg}
              onError={(e) => (e.target.style.display = "none")}
            />
            <div style={styles.featureContent}>
              <h3 style={styles.featureTitle}>{currentFeature.title}</h3>
              {currentFeature.points.map((pt, i) => (
                <div key={i} style={styles.featurePoint}>
                  <span style={styles.bullet} />
                  <span>{pt}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Map Section */}
      <section style={styles.mapSection}>
        <p style={{ ...styles.sectionLabel, color: "#14e3e3" }}>
          Connect Across Continents
        </p>
        <h2 style={{ ...styles.sectionTitle, color: "#fff", margin: 0 }}>
          Across the World
        </h2>
        <img
          src="/themes/thesaas/img/c2c/mapUpdateV2Alpha.png"
          alt="Global coverage map"
          style={styles.mapImg}
          onError={(e) => (e.target.style.display = "none")}
        />
      </section>

      {/* Benefits */}
      <div style={styles.section}>
        <p style={styles.sectionLabel}>Benefits</p>
        <h2 style={styles.sectionTitle}>Build Your Business</h2>

        <div className="features-benefits-layout" style={styles.benefitsLayout}>
          <div style={styles.benefitNav} aria-label="Benefit options">
            {benefitsData.map((b) => (
              <button
                key={b.id}
                type="button"
                style={styles.benefitTab(activeBenefit === b.id)}
                onClick={() => setActiveBenefit(b.id)}
              >
                <span style={styles.benefitTabTitle}>{b.label}</span>
              </button>
            ))}
          </div>

          {currentBenefit && (
            <div style={styles.benefitDetail}>
              <img
                src={currentBenefit.image}
                alt={currentBenefit.title}
                style={{ width: "220px", maxWidth: "100%", borderRadius: "10px", objectFit: "contain" }}
                onError={(e) => (e.target.style.display = "none")}
              />
              <div style={{ flex: 1, minWidth: "220px" }}>
                <h3 style={styles.benefitDetailTitle}>{currentBenefit.title}</h3>
                <p style={styles.benefitDetailDesc}>{currentBenefit.description}</p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Push Notification */}
      <section style={styles.pushSection}>
        <div className="features-push-layout" style={{ ...styles.section, ...styles.pushLayout }}>
          <div>
            <p style={styles.sectionLabel}>Engagement</p>
            <h2 style={{ ...styles.sectionTitle, marginBottom: "18px" }}>
              Push Notification
            </h2>
            <p style={styles.pushDescription}>
Receive real-time notifications whenever a call, SMS, or email comes from the source location, so you can respond with the right context.            </p>
          </div>
          <div style={styles.pushVideoFrame}>
            <video
              src={pushNotificationVideo}
              style={styles.pushVideo}
              autoPlay
              muted
              loop
              playsInline
              aria-label="Push notification feature preview"
            />
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section style={styles.faqSection}>
        <div style={styles.section}>
          <p style={styles.sectionLabel}>Frequently Asked Questions</p>
          <h2 style={styles.sectionTitle}>FAQ's</h2>
          {faqData.map((faq, i) => (
            <div key={i} style={styles.faqItem}>
              <div
                style={styles.faqQuestion}
                onClick={() => setOpenFaq(openFaq === i ? null : i)}
              >
                <span>{faq.question}</span>
                <span style={{ fontSize: "20px", color: "var(--cyan-400)" }}>
                  {openFaq === i ? "−" : "+"}
                </span>
              </div>
              {openFaq === i && (
                <p style={styles.faqAnswer}>{faq.answer}</p>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
